import { Inject } from '@odinjs/odin';

import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ClickEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { MapperAPI, PanelAPI } from '@philips-internal/oswald-ui-components';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Value } from '@philips-internal/oswald-ui-core';

import { FragmentNames, ReservedBloodProductsAliases } from '../../../../codegen';
import { ApplicationRoute } from '../../../../constants/routes';
import BaseController from '../../../BaseController';
import InformationBarUtils from '../../../commons/header/information-bar-header-utils';
import ReservedBloodProductsContext from './reserved-blood-products-service';
import { ReservedProduction } from '../blood-management/blood-management-types';
import { Endpoint } from '../../../../constants/endpoints';

import './reserved-blood-products.css';

@Controller({ component: ReservedBloodProductsAliases.RESERVED_BLOOD_PRODUCTS_LAYOUT, fragment: FragmentNames.RESERVED_BLOOD_PRODUCTS })
export default class ReservedBloodProductsController extends BaseController {

  @Inject(ReservedBloodProductsAliases.RESERVED_BLOOD_PRODUCTS_PANEL)
  private reservedBloodProductsPanelApi!: PanelAPI;

  @OnMount(ReservedBloodProductsAliases.RESERVED_BLOOD_PRODUCTS_LAYOUT)
  handleMountReservedBloodProductsLayout(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    this.context.set({ encounterId, patientId });
    InformationBarUtils.collapsedBar = true;

    this.fetchReservedBloodProducts().then((reservedProducts) => {
      if (!reservedProducts.length) {
        return
      }
      this.reservedBloodProductsPanelApi.setVisible(true)
      this.context.set({ reservedProducts })
    }).catch(() => {
      this.reservedBloodProductsPanelApi.setVisible(false)
    })
  }

  @OnMount(ReservedBloodProductsAliases.RESERVED_BLOOD_PRODUCTS_MAPPER)
  handleMountReservedBloodProductsMapper(event: MountEvent): void {
    const mapperApi = event.target as MapperAPI;
    const reservedProducts = this.context.get('reservedProducts') as unknown as Record<string, Value>[];

    mapperApi.setData(reservedProducts)
  }

  private fetchReservedBloodProducts(): Promise<ReservedProduction[]> {
    const encounterId = this.context.get('encounterId');
    const finishedItems = this.context.get('performedItems') ? 'S' : 'N';
    return HttpService.get(Endpoint.EMAR_GET_RESERVED_BLOOD_PRODUCTS, { encounterId, finishedItems }).then((response) => response.body as ReservedProduction[]);
  }

  @OnClick(ReservedBloodProductsAliases.RESERVED_BLOOD_PRODUCTS_DECK)
  handleClickReservedBloodProductsCardContainer(event: ClickEvent): void {
    const { id, statusItem } = event.value as ReservedProduction;
    ReservedBloodProductsContext.set({
      ...event.value
    })
    applicationContext.redirect(ApplicationRoute.ADEP_REVERSED_BLOOD_PRODUCTS_VIEWER, { reservedId: id, statusItem: statusItem } )
  }
}